import ENDPOINT from 'constants/endPoint';
import axiosClient from 'utils/axios';

export default {
  async getExtranetNotification(payload) {
    const path = `${ENDPOINT.EXTRANET_NOTIFICATION}?place=${payload}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async readExtranetNotification(payload) {
    const path = `${ENDPOINT.EXTRANET_NOTIFICATION}/read`;
    const response = await axiosClient.post(path, payload);

    return response.data;
  },
};
